//Inline Asset Icons
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import LinkIcon from '@mui/icons-material/Link';
import ImageIcon from '@mui/icons-material/Image';
import HtmlIcon from '@mui/icons-material/Html';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import DescriptionIcon from '@mui/icons-material/Description';
import CollectionsOutlinedIcon from '@mui/icons-material/CollectionsOutlined';
import BallotOutlinedIcon from '@mui/icons-material/BallotOutlined';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import InsertPageBreakIcon from '@mui/icons-material/InsertPageBreak';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import EditNoteIcon from '@mui/icons-material/EditNote';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

//Unknown ToC Item Icon
import HelpIcon from '@mui/icons-material/Help';

//Custom Icons
import FormatParagraph from '../CustomIcons/FormatParagraph';
import FormatHeading from '../CustomIcons/FormatHeading';

export const itemIconStyle = {
  minWidth: '0',
  '& .MuiSvgIcon-root': { height: '1.5rem', width: '1.5rem' },
};

export const anchorTypes = ['heading', 'horizontalRule', 'paragraph', 'table'];

export const nodeTypeIconMap = [
  { type: 'heading', icon: <FormatHeading /> },
  { type: 'paragraph', icon: <FormatParagraph /> },
  { type: 'audio', icon: <VolumeUpIcon /> },
  { type: 'video', icon: <VideocamOutlinedIcon /> },
  { type: 'pdf', icon: <PictureAsPdfIcon /> },
  { type: 'link', icon: <LinkIcon /> },
  { type: 'image', icon: <ImageIcon /> },
  { type: 'html', icon: <HtmlIcon /> },
  { type: 'file', icon: <AttachFileOutlinedIcon /> },
  { type: 'form', icon: <ListAltOutlinedIcon /> },
  { type: 'collection', icon: <CollectionsOutlinedIcon /> },
  { type: 'poll', icon: <BallotOutlinedIcon /> },
  { type: 'table', icon: <TableChartOutlinedIcon /> },
  { type: 'unknown', icon: <HelpIcon /> },
  { type: 'article', icon: <DescriptionIcon /> },
  { type: 'horizontalRule', icon: <HorizontalRuleIcon /> },
  { type: 'pageBreak', icon: <InsertPageBreakIcon /> },
  { type: 'inlineNote', icon: <EditNoteIcon /> },
  { type: 'bulletList', icon: <FormatListBulletedIcon /> },
  { type: 'orderedList', icon: <FormatListNumberedIcon /> },
  { type: 'blockquote', icon: <FormatQuoteIcon /> },

  // Add more mappings for other node types
  // ...
];

export const nodeTypeTextMap = [
  { type: 'horizontalRule', text: 'Horizontal Rule' },
  { type: 'pageBreak', text: 'Page Break' },
  { type: 'inlineNote', text: 'Inline Note' },
  { type: 'heading', text: 'Heading' },
  { type: 'paragraph', text: 'Paragraph' },
  { type: 'audio', text: 'Inline Audio' },
  { type: 'video', text: 'Inline Video' },
  { type: 'pdf', text: 'Inline PDF' },
  { type: 'link', text: 'Link' },
  { type: 'image', text: 'Inline Image' },
  { type: 'html', text: 'Inline HTML' },
  { type: 'file', text: 'Inline File' },
  { type: 'form', text: 'Inline Form' },
  { type: 'collection', text: 'Inline Collection' },
  { type: 'poll', text: 'Inline Poll' },
  { type: 'table', text: 'Table' },
  { type: 'unknown', text: 'Unknown' },
  { type: 'article', text: 'Inline Article' },
  { type: 'bulletList', text: 'Bullet List' },
  { type: 'orderedList', text: 'Ordered List' },
  { type: 'blockquote', text: 'Blockquote' },

  // Add more mappings for other node types
  // ...
];
